import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography';

// Container for the grid
const GridContainer = styled.div`
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  gap: 20px
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 
  }

  @media (max-width: 80px) {
    grid-template-columns: 1fr; 
  }
      @media (min-width: 600px) {
    padding-left: 56px;
    padding-right: 56px;
  }
`;

// Card for each item in the grid
const Card = styled.div`
  background-color:transparent;


  padding: 8px 20px;

  
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// Icon at the top of the card
const Icon = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 10px; 
`;

// Title of the card
const Title = styled.h3`

 
  margin: 0 0 10px 0; 
  text-align: left;

`;

// Paragraph in the card


// Main Features component
const Features = () => {
  return (
    <GridContainer>
      <Card>
        <Icon src="./static/features_icon_1.png" alt="Feature 1" />
        <Title><Typography size="30px" weight="700px">Screen Time Tracking</Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >
          Easily monitor your screen time with detailed reports and insights,
          helping you manage digital consumption and balance online-offline activities effectively.

        </Typography>
      </Card>
      <Card>
        <Icon src="./static/features_icon_2.png" alt="Feature 2" />
        <Title><Typography size="30px" weight="700px">Personalized Recommendations of Offline Activities
        </Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >
          Receive tailored suggestions for offline activities that match your interests and lifestyle,
          encouraging healthier habits and more meaningful real-world experiences.
        </Typography>
      </Card>
      <Card>
        <Icon src="./static/features_icon_3.png" alt="Feature 3" />
        <Title><Typography size="30px" weight="700px">Various Productivity Tools
        </Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >
        Access a range of productivity tools, including to-do lists, timers, and app blockers, 
        designed to boost focus and keep you organized efficiently.

        </Typography>
      </Card>
      <Card>
        <Icon src="./static/features_icon_4.png" alt="Feature 4" />
        <Title><Typography size="30px" weight="700px">Gamification and Challenges with Rewards
        </Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >Participate in exciting challenges and earn rewards,
          turning your goals into fun, engaging tasks that motivate you to maintain healthy habits.
        </Typography>
      </Card>
      <Card>
        <Icon src="./static/features_icon_5.png" alt="Feature 5" />
        <Title><Typography size="30px" weight="700px">Personalized Notifications Using AI</Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >Stay on track with AI-driven personalized notifications
          that remind you of important tasks, updates, and achievements based on your behavior and preferences.
        </Typography>
      </Card>
      <Card>
        <Icon src="./static/features_icon_6.png" alt="Feature 6" />
        <Title><Typography size="30px" weight="700px">Book Tickets
        </Typography></Title>
        <Typography size="24px" weight="500px" color="#6F6D7B" >
          Easily book tickets for events, activities, and experiences directly within the app,
          making it convenient to engage with offline activities seamlessly.
        </Typography>
      </Card>
    </GridContainer>
  );
};

export default Features;
